import React from 'react'
import Svg, { SvgProps } from '@/components/svg'
import iconLogoWiggot from '../build/icon-logo-wiggot'

export const IconLogoWiggotComponent: React.FC<Omit<SvgProps, 'src'>> = (
  props
) => {
  return <Svg {...props} src={iconLogoWiggot} />
}

export default IconLogoWiggotComponent
